import userProfileReducer from "./reducers";
export { default as userProfileTypes } from "./types";
export { default as userProfileActions } from "./actions";
export { default as userProfileOperations } from "./operations";
export default userProfileReducer;
